"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initWorkerAsync = exports.sleepAsync = void 0;
const timer_1 = __importDefault(require("./timer"));
const parseTokens_1 = require("./parseTokens");
function get_browser() {
    let ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return { name: 'ie', version: (tem[1] || '') };
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR|Edge\/(\d+)/);
        if (tem != null) {
            let version = tem[1];
            if (!version) {
                const splits = ua.split(tem[0] + "/");
                if (splits.length > 1) {
                    version = splits[1];
                }
            }
            return { name: 'opera', version };
        }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1]);
    }
    return {
        name: M[0].toLowerCase(),
        version: M[1]
    };
}
let keepAliveServiceWorkerTimeoutId = null;
const sleepAsync = (milliseconds) => {
    return new Promise(resolve => timer_1.default.setTimeout(resolve, milliseconds));
};
exports.sleepAsync = sleepAsync;
const keepAlive = () => {
    try {
        const promise = fetch('/OidcKeepAliveServiceWorker.json');
        promise.catch(error => { console.log(error); });
        (0, exports.sleepAsync)(230 * 1000).then(keepAlive);
    }
    catch (error) {
        console.log(error);
    }
};
const isServiceWorkerProxyActiveAsync = () => {
    try {
        return fetch('/OidcKeepAliveServiceWorker.json', {
            headers: {
                'oidc-vanilla': "true"
            }
        })
            .then((response) => {
            return response.statusText === 'oidc-service-worker';
        }).catch(error => { console.log(error); });
    }
    catch (error) {
        console.log(error);
    }
};
const sendMessageAsync = (registration) => (data) => {
    return new Promise(function (resolve, reject) {
        const messageChannel = new MessageChannel();
        messageChannel.port1.onmessage = function (event) {
            if (event.data && event.data.error) {
                reject(event.data.error);
            }
            else {
                resolve(event.data);
            }
        };
        registration.active.postMessage(data, [messageChannel.port2]);
    });
};
const initWorkerAsync = (serviceWorkerRelativeUrl, configurationName) => __awaiter(void 0, void 0, void 0, function* () {
    if (typeof window === "undefined" || typeof navigator === "undefined" || !navigator.serviceWorker || !serviceWorkerRelativeUrl) {
        return null;
    }
    const { name, version } = get_browser();
    if (name == "chrome" && parseInt(version) < 90) {
        return null;
    }
    if (name == "opera") {
        if (!version) {
            return null;
        }
        if (parseInt(version.split(".")[0]) < 80) {
            return null;
        }
    }
    if (name == "ie") {
        return null;
    }
    const registration = yield navigator.serviceWorker.register(serviceWorkerRelativeUrl);
    try {
        yield navigator.serviceWorker.ready;
    }
    catch (err) {
        return null;
    }
    const saveItemsAsync = (items) => {
        return sendMessageAsync(registration)({ type: "saveItems", data: items, configurationName });
    };
    const loadItemsAsync = () => {
        return sendMessageAsync(registration)({ type: "loadItems", data: null, configurationName });
    };
    const unregisterAsync = () => __awaiter(void 0, void 0, void 0, function* () {
        return yield registration.unregister();
    });
    const clearAsync = (status) => {
        return sendMessageAsync(registration)({ type: "clear", data: { status }, configurationName });
    };
    const initAsync = (oidcServerConfiguration, where) => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield sendMessageAsync(registration)({
            type: "init",
            data: { oidcServerConfiguration, where },
            configurationName
        });
        // @ts-ignore
        return { tokens: (0, parseTokens_1.parseOriginalTokens)(result.tokens, null), status: result.status };
    });
    const startKeepAliveServiceWorker = () => {
        if (keepAliveServiceWorkerTimeoutId == null) {
            keepAliveServiceWorkerTimeoutId = "not_null";
            keepAlive();
        }
    };
    const setSessionStateAsync = (sessionState) => {
        return sendMessageAsync(registration)({ type: "setSessionState", data: { sessionState }, configurationName });
    };
    const getSessionStateAsync = () => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield sendMessageAsync(registration)({ type: "getSessionState", data: null, configurationName });
        // @ts-ignore
        return result.sessionState;
    });
    const setNonceAsync = (nonce) => {
        return sendMessageAsync(registration)({ type: "setNonce", data: { nonce }, configurationName });
    };
    const NONCE_TOKEN = 'NONCE_SECURED_BY_OIDC_SERVICE_WORKER';
    const getNonceAsync = () => __awaiter(void 0, void 0, void 0, function* () {
        // @ts-ignore
        const keyNonce = NONCE_TOKEN + '_' + configurationName;
        return { nonce: keyNonce };
    });
    return {
        saveItemsAsync,
        loadItemsAsync,
        clearAsync,
        initAsync,
        // getAccessTokenPayloadAsync,
        startKeepAliveServiceWorker,
        isServiceWorkerProxyActiveAsync,
        setSessionStateAsync,
        getSessionStateAsync,
        setNonceAsync,
        getNonceAsync,
        unregisterAsync,
    };
});
exports.initWorkerAsync = initWorkerAsync;
//# sourceMappingURL=initWorker.js.map